import React from 'react';
import SideBar, {full_items, home_page_only} from '../../navigation/sidebar.js';
import { AppLayout } from '@amzn/awsui-components-react'; 
import SandboxTable from './table/table.js';
import {PageStage} from "../../constants/constants";
import AppContext from "../../context/AppContext";

class Sandboxes extends React.Component {
    static contextType = AppContext;
    render() {
        return (
            <AppLayout
                content={<SandboxTable />}
                navigation={<SideBar activeHref="/sandboxes" items={PageStage.FULLY_LOADED === this.context.pageStage ? full_items : home_page_only}/>}
                navigationOpen={true}
                toolsHide={true}
            />
        );
    }
}

export default Sandboxes;
